import { EnergiaIcon, TecnologiaIcon, SaludIcon, MaterialesIndustrialesIcon, FinanzasIcon, InfraestructurasIcon, ComunicacionesIcon, OtrosIcon } from '../../../Products/sectorsIcons';
export var breakdownDefinitions = [{
  id: 1,
  type: 'MC',
  drawer: 'Giant',
  label: 'Giantcap',
  code: '1',
  documentation: 'Market Capitalization - Giant'
}, {
  id: 2,
  type: 'MC',
  drawer: 'Large',
  label: 'Largecap',
  code: '2',
  documentation: 'Market Capitalization - Large'
}, {
  id: 3,
  type: 'MC',
  drawer: 'Medium',
  label: 'Mediumcap',
  code: '3',
  documentation: 'Market Capitalization - Medium'
}, {
  id: 4,
  type: 'MC',
  drawer: 'Small',
  label: 'Smallcap',
  code: '4',
  documentation: 'Market Capitalization - Small'
}, {
  id: 5,
  type: 'MC',
  drawer: 'Micro',
  label: 'Microcap',
  code: '5',
  documentation: 'Market Capitalization - Micro'
}, {
  id: 6,
  type: 'AA',
  drawer: 'Stock',
  code: '1',
  documentation: 'Asset Allocation - Stock',
  label: 'Acciones'
}, {
  id: 7,
  type: 'AA',
  drawer: 'Bond',
  code: '3',
  documentation: 'Asset Allocation - Bond',
  label: 'Bonos'
}, {
  id: 8,
  type: 'AA',
  drawer: 'PreferredActions',
  code: '5',
  documentation: 'Asset Allocation - PreferredActions',
  label: 'Acciones preferentes'
}, {
  id: 9,
  type: 'AA',
  drawer: 'Convertible',
  code: '6',
  documentation: 'Asset Allocation - Convertible',
  label: 'Convertible'
}, {
  id: 10,
  type: 'AA',
  drawer: 'Cash',
  code: '7',
  documentation: 'Asset Allocation - Cash',
  label: 'Cash'
}, {
  id: 11,
  type: 'AA',
  drawer: 'Other',
  code: '8',
  documentation: 'Asset Allocation - Other',
  label: 'Otros activos'
}, {
  id: 12,
  type: 'SS',
  drawer: 'Basic Materials',
  code: '101',
  documentation: 'Global Stock Sector - Basic Materials',
  label: 'Materiales Básicos',
  icon: MaterialesIndustrialesIcon
}, {
  id: 13,
  type: 'SS',
  drawer: 'Communication Services',
  code: '308',
  documentation: 'Global Stock Sector - Communication Services',
  label: 'Servicios de Comunicación',
  icon: ComunicacionesIcon
}, {
  id: 14,
  type: 'SS',
  drawer: 'Consumer Cyclical',
  code: '102',
  documentation: 'Global Stock Sector - Consumer Cyclical',
  label: 'Consumo Cíclico',
  icon: OtrosIcon
}, {
  id: 15,
  type: 'SS',
  drawer: 'Consumer Defensive',
  code: '205',
  documentation: 'Global Stock Sector - Consumer Defensive',
  label: 'Consumo Defensivo',
  icon: OtrosIcon
}, {
  id: 16,
  type: 'SS',
  drawer: 'Healthcare',
  code: '206',
  documentation: 'Global Stock Sector - Healthcare',
  label: 'Salud',
  icon: SaludIcon
}, {
  id: 17,
  type: 'SS',
  drawer: 'Industrials',
  code: '310',
  documentation: 'Global Stock Sector - Industrials',
  label: 'Industriales',
  icon: MaterialesIndustrialesIcon
}, {
  id: 18,
  type: 'SS',
  drawer: 'Real Estate',
  code: '104',
  documentation: 'Global Stock Sector - Real Estate',
  label: 'Inmobiliario',
  icon: InfraestructurasIcon
}, {
  id: 19,
  type: 'SS',
  drawer: 'Technology',
  code: '311',
  documentation: 'Global Stock Sector - Technology',
  label: 'Tecnología',
  icon: TecnologiaIcon
}, {
  id: 20,
  type: 'SS',
  drawer: 'Energy',
  code: '309',
  documentation: 'Global Stock Sector - Energy',
  label: 'Energía',
  icon: EnergiaIcon
}, {
  id: 21,
  type: 'SS',
  drawer: 'Financial Services',
  code: '103',
  documentation: 'Global Stock Sector - Financial Services',
  label: 'Servicios Financieros',
  icon: FinanzasIcon
}, {
  id: 22,
  type: 'SS',
  drawer: 'Utilities',
  code: '207',
  documentation: 'Global Stock Sector - Utilities',
  label: 'Servicios Públicos',
  icon: InfraestructurasIcon
}, {
  id: 23,
  type: 'RE',
  drawer: 'Estados Unidos',
  label: 'Estados Unidos',
  code: '1',
  documentation: ' Regional Exposure - Estados Unidos'
}, {
  id: 24,
  type: 'RE',
  drawer: 'Canadá',
  label: 'Canadá',
  code: '2',
  documentation: 'Regional Exposure - Canadá'
}, {
  id: 25,
  type: 'RE',
  drawer: 'Iberoamérica',
  label: 'Iberoamérica',
  code: '3',
  documentation: ' Regional Exposure - Iberoamérica'
}, {
  id: 26,
  type: 'RE',
  drawer: 'Reino Unido',
  label: 'Reino Unido',
  code: '4',
  documentation: 'Regional Exposure - Reino Unido'
}, {
  id: 27,
  type: 'RE',
  drawer: 'Zona Euro',
  label: 'Zona Euro',
  code: '5',
  documentation: 'Regional Exposure - Zona Euro'
}, {
  id: 28,
  type: 'RE',
  drawer: 'Europa (ex-Zona Euro)',
  label: 'Europa (ex-Zona Euro)',
  code: '6',
  documentation: 'Regional Exposure - Europa (ex-Zona Euro)'
}, {
  id: 29,
  type: 'RE',
  drawer: 'Europa Emergente',
  label: 'Europa Emergente',
  code: '7',
  documentation: 'Regional Exposure - Europa Emergente'
}, {
  id: 30,
  type: 'RE',
  drawer: 'África',
  label: 'África',
  code: '8',
  documentation: 'Regional Exposure - África'
}, {
  id: 31,
  type: 'RE',
  drawer: 'Oriente Medio',
  label: 'Oriente Medio',
  code: '9',
  documentation: 'Regional Exposure - Oriente Medio'
}, {
  id: 32,
  type: 'RE',
  drawer: 'Japón',
  label: 'Japón',
  code: '10',
  documentation: 'Regional Exposure - Japón'
}, {
  id: 33,
  type: 'RE',
  drawer: 'Australasia',
  label: 'Australasia',
  code: '11',
  documentation: 'Regional Exposure - Australasia'
}, {
  id: 34,
  type: 'RE',
  drawer: 'Asia Desarrollada',
  label: 'Asia Desarrollada',
  code: '12',
  documentation: 'Regional Exposure - Asia Desarrollada'
}, {
  id: 35,
  type: 'RE',
  drawer: 'Asia Emergente',
  label: 'Asia Emergente',
  code: '13',
  documentation: 'Regional Exposure - Asia - Emergente'
}, {
  id: 36,
  type: 'RE',
  drawer: 'Mercado Emergente',
  label: 'Mercado Emergente',
  code: '14',
  documentation: 'Regional Exposure - Mercado Emergente'
}, {
  id: 37,
  type: 'RE',
  drawer: 'País Desarrollado',
  label: 'País Desarrollado',
  code: '15',
  documentation: 'Regional Exposure - País Desarrollado'
}, {
  id: 38,
  type: 'RE',
  drawer: 'No Clasificado',
  label: 'No Clasificado',
  code: '16',
  documentation: 'Regional Exposure - No Clasificado'
}];